import React from 'react';
import { ContentCard } from '../components';
import { myTechnologies } from '../utils/text-data/my-technologies';

export const TechnologiesSection = () => {
  return (
    <ContentCard className={'bg-transparent shadow-none md:p-0 p-0'} cardTitle={'Technologies I work with'}>
      <div className='flex gap-1 flex-wrap'>
        {myTechnologies?.map((item, key) => (
          <p key={key} className='text-base border py-1 px-3 rounded-xl bg-orange'>
            {item}
          </p>
        ))}
      </div>
    </ContentCard>
  );
};
